import { IBookingScheduler } from 'src/app/models';
import { IBookingsSchedulersState, IPagination } from '../states';

export const initialBookingsSchedulerState: IBookingsSchedulersState = {
  value: [] as IBookingScheduler[],
  isFetchingBookingsSchedulers: false,
  pagination: {} as IPagination,
};
